import React from 'react';

import {connect} from "react-redux";
import * as rateUtils from "../../utils/clientRate";
import l10n from "../../l10n/localization";
import * as rateActions from "../../actions/clientRate";
import Loader from "../common/Loader";
import Validate from 'validate.js';
import validation from '../../validation/clientRate';
import Checkbox from "./fields/Checkbox";
import * as utilsCommon from "../../utils/utils";
import CWForm from "./CWForm";

class ClientRateForm extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            item: this.props.item.item,
            fog: this.props.item.fog,
            client: this.props.item.client,
            schema: {
                type: "object",
                properties: {
                    name: {
                        type: "string",
                        title: l10n.client.rate.name
                    },
                    rate: {
                        type: "number",
                        title: l10n.client.rate.rate,
                    },
                    franchise: {
                        type: "number",
                        title: l10n.client.rate.franchise,
                    },
                    isMarineOnly: {
                        type: "boolean",
                        title: l10n.client.rate.isMarineOnly,
                        locked: this.props.saving
                    }
                }
            },
            uiSchema: {
                id: {"ui:widget": "hidden"},
                isMarineOnly: {"ui:field": "checkbox"},
            },
            fields: {
                checkbox: Checkbox
            },
            isDirty: false,
            formData: rateUtils.clientRateToForm(this.props.item.item)
        }
    }

    onSubmit = ({formData}) => {
        let form = Object.assign({}, {...formData});

        if (utilsCommon.notNullNorUndefined(this.state.item) && (utilsCommon.notNullNorUndefined(this.state.item.id) || utilsCommon.notNullNorUndefined(this.props.newlyCreatedElement))) {
            if (utilsCommon.notNullNorUndefined(this.props.newlyCreatedElement)) {
                form.client = utilsCommon.notNullNorUndefined(this.state.fog) ? this.state.fog.client.id : (utilsCommon.notNullNorUndefined(this.state.client) ? this.state.client.id : null);
                this.setState({item: {...formData, id: this.props.newlyCreatedElement}}, () => {
                    form.id = this.props.newlyCreatedElement;
                    if (form.creationDate !== undefined) {
                        delete form.creationDate;
                    }

                    if (form.isMarineOnly === undefined) {
                        form.isMarineOnly = false;
                    }
                    this.props.dispatch(rateActions.edit(form));
                })
            } else {
                form.client = utilsCommon.notNullNorUndefined(this.state.fog) ? this.state.fog.client.id : (utilsCommon.notNullNorUndefined(this.state.client) ? this.state.client.id : null);
                this.setState({item: formData}, () => {
                    if (form.creationDate !== undefined) {
                        delete form.creationDate;
                    }

                    if (form.isMarineOnly === undefined) {
                        form.isMarineOnly = false;
                    }
                    this.props.dispatch(rateActions.edit(form));
                })
            }
        } else {
            form.client = utilsCommon.notNullNorUndefined(this.state.fog) ? this.state.fog.client.id : (utilsCommon.notNullNorUndefined(this.state.client) ? this.state.client.id : null);
            this.setState({item: formData}, () => {
                form.client = utilsCommon.notNullNorUndefined(this.state.fog) ? this.state.fog.client.id : (utilsCommon.notNullNorUndefined(this.state.client) ? this.state.client.id : null);
                if (form.isMarineOnly === undefined) {
                    form.isMarineOnly = false;
                }

                this.props.dispatch(rateActions.add(form));
            })
        }
        this.setState((state) => {return {...state, isDirty: false,formData: formData};});
    };

    validate = (formData, errors) => {
        let validationErrors = Validate(formData, validation, {fullMessages: false});

        if (validationErrors !== undefined) {
            for (let key in validationErrors) {
                if (validationErrors.hasOwnProperty(key)) {
                    if (errors[key] !== undefined) {
                        for (let i = 0; i < validationErrors[key].length; i++) {
                            errors[key].addError(validationErrors[key][i]);
                        }
                    }
                }
            }
        }
        return errors;
    };

    handleChange = (formData) => {
        let nextState = this.state;

        if(!this.state.isDirty) {
            nextState.isDirty = true;
        }
        nextState.formData = formData.formData;
        this.setState((state) => {return {...state, nextState}});
    };

    handleError = () => {
        this.props.dispatch(rateActions.errorMessage(l10n.validation.form_error));
    };

    render() {
        if (this.props.loading) {
            return (<div><Loader /></div>)
        }
        let formClassName = (this.state.isDirty) ? 'clientrate-form dirty':'clientrate-form';

        return (
            <div className={formClassName}>
                <h1>{l10n.common.clientRates}</h1>
                <CWForm
                    schema={this.state.schema}
                    formData={this.state.formData}
                    showErrorList={false}
                    fields={this.state.fields}
                    uiSchema={this.state.uiSchema}
                    validate={this.validate}
                    liveValidate={true}
                    onError={this.handleError}
                    onChange={({formData})=> {this.handleChange({formData})}}
                    onSubmit={this.onSubmit}>
                    <div>
                        <button type="submit" className="btn btn-info validate" disabled={this.props.saving}>{l10n.common.save}</button>
                    </div>
                </CWForm>
            </div>
        )
    }
}

export default connect((state) => {
    return Object.assign({}, {
        loading: state.clientRate.loading,
        saving: state.clientRate.saving,

        newlyCreatedElement: state.creation.newlyCreatedClientRate,
    });
})(ClientRateForm);


// WEBPACK FOOTER //
// ./src/components/forms/ClientRateForm.js